import { Component, OnInit, Input, Output, TemplateRef, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { ButtonModel } from '../../models/button/button.model';
import { WizardStepModel } from '../../models/wizard/wizard-step.model';
import { WizardStepStylingModel } from '../../models/wizard/wizard-step-styling.model';
import { WizardStepTemplates } from '../../templates/wizard-step.template';
import { CfCoreComponent } from '../core/core.component';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>Wizard Step component based on Angular Material Tabs</p>
 * <p>Example of using:</p>
 * <pre>
 * <code><</code>cf-wizard-step<code>></code><code><</code><code>/</code>cf-wizard-step<code>></code>
 * </pre>
 */
export class CfWizardStepComponent extends CfCoreComponent implements OnInit {
/**
 * <p>Example of model:</p>
 * <pre>{{'{'}}
 *  label: 'Card label'
 * {{'}'}}</pre>
 * <h4>label: string</h4>
 * Step label text
 */
properties: WizardStepModel;
/**
 * Object for all styling properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>label: StylingModel</h4>
 * Styling properties for step label
 * <h4>iconIndex: StylingModel</h4>
 * Styling properties for step index icon
 * <h4>prefixIndex: StylingModel</h4>
 * Styling properties for step index prefix
 */
styling: WizardStepStylingModel;
/**
 * Step label text
 * @param {?} value
 * @return {?}
 */
set label(value: string) { this.properties.label = value; }
/**
 * Step valid state
 * @param {?} value
 * @return {?}
 */
set isValid(value: boolean) { this.properties.isValid = value; }
/**
 * @hidden
 */
stepHeader;
/**
 * @hidden
 */
stepContent;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new WizardStepModel();
    this.styling = new WizardStepStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('wizard-step', WizardStepTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'WIZARD-STEP').then( sampler => {
        // console.log('WIZARD-STEP', this.id, this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-wizard-step',
  template: "<ng-template #stepHeader><ng-content select=\"[header]\"></ng-content></ng-template> <ng-template #stepContent><ng-content select=\"[content]\"></ng-content></ng-template>",
  styles: [".mat-tab-body-content { height: 100%; overflow: auto; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'label': [{ type: Input, args: ['label', ] },],
'isValid': [{ type: Input, args: ['isValid', ] },],
'stepHeader': [{ type: ViewChild, args: ['stepHeader', ] },],
'stepContent': [{ type: ViewChild, args: ['stepContent', ] },],
};
}

function CfWizardStepComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfWizardStepComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfWizardStepComponent.ctorParameters;
/** @type {?} */
CfWizardStepComponent.propDecorators;
/**
 * <p>Example of model:</p>
 * <pre>{{'{'}}
 *  label: 'Card label'
 * {{'}'}}</pre>
 * <h4>label: string</h4>
 * Step label text
 * @type {?}
 */
CfWizardStepComponent.prototype.properties;
/**
 * Object for all styling properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>label: StylingModel</h4>
 * Styling properties for step label
 * <h4>iconIndex: StylingModel</h4>
 * Styling properties for step index icon
 * <h4>prefixIndex: StylingModel</h4>
 * Styling properties for step index prefix
 * @type {?}
 */
CfWizardStepComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfWizardStepComponent.prototype.stepHeader;
/**
 * @hidden
 * @type {?}
 */
CfWizardStepComponent.prototype.stepContent;
/**
 * @hidden
 * @type {?}
 */
CfWizardStepComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
